export const globalDefines = {
    defaultToastDuration    : 3000,
    minPasswordLength       : 6,

    polygonFillColor        : '#0000FF',
    polygonFillOpacity      : 0.35,
    polygonStrokeColor      : '#0000FF',
    polygonStrokeOpacity    : 0.8,
    polygonStrokeWeight     : 2,

    drawingPolygonFillColor        : '#FF0000',
    drawingPolygonFillOpacity      : 0.35,
    drawingPolygonStrokeColor      : '#FF0000',
    drawingPolygonStrokeOpacity    : 0.8,
    drawingPolygonStrokeWeight     : 2,
}

export const propertyNames = {
    Checks      : 'checks',
    ExtraHours  : 'extraHours',
    Geolocation : 'geolocation',
    Name        : 'name',
    State       : 'state',
    Tokens      : 'tokens',
    UUID_device : 'uuid_device'
}

export const tableNames = {
    APs             : 'pendingAPs',
    Areas           : 'areas',
    Checks          : 'checks',
    Coefficients    : 'coefficients',
    Configuration   : 'config',
    ExtraDay        : 'extraDay',
    MicRRHH         : 'MicRRHHData',
    Holidays        : 'holidays',
    Notifications   : 'notifications',
    PendingHolidays : 'pendingHolidays',
    Petitions       : 'petitions',
    Properties      : 'properties',
    Repo            : '',
    Timetables      : 'timetables',
    User            : 'users',
    UserChecks      : 'userChecks',
    UserPetitions   : 'userPetitions',
    Workplace       : 'workplaces'
}

export const availableReports = [
    { name: 'Resumen usuario',  admin: false,  page: 'ReportUserPage' },
    { name: 'Resumen global',   admin: true,   page: 'ReportGlobalPage' },
    { name: 'Resumen mensual',  admin: false,  page: 'ReportMonthPage' },
]

export const version = '1.1.4'


// WEBPACK FOOTER //
// ./src/app/app.constants.ts